import OfferRequestSentPage from '../components/OfferRequestSentPage'
import { connect } from 'react-redux'
import { newPlan } from '../actions/plan'


const mapStateToProps = (state, ownProps) => {
    return {
        sendingPlan: state.planService.isSaving && state.plan.sent === true,
        notConnected: state.planService.notConnected
    }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
    onNewPlanClick:() => {
    dispatch(newPlan());
  }
})

const VisibleOfferRequestSentPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(OfferRequestSentPage)

export default VisibleOfferRequestSentPage

